import { render, staticRenderFns } from "./AnxietyChart.vue?vue&type=template&id=f88c3f0c&"
import script from "./AnxietyChart.vue?vue&type=script&lang=js&"
export * from "./AnxietyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports